export default __webpack_public_path__ + "static/media/04.62865fac.jpg";